import React, { useState , useEffect, useContext} from "react";
import { AddNode, ArrowDown, ArrowUp, DropArrow, SearchIcon, SearchIconWhite } from "../../../assets/images";
import { MultiSelect } from "react-multi-select-component";
import { Accordion, Card, Tab, Tabs } from "react-bootstrap";
import EcsAccordion from "./EcsAccordion";
import { getSiteList, getEscalationConditionList, getEscalationInputList } from "../../../services/alertGridServices";
import { useAlertType } from "../../../CustomHooks/useAlertType";
import { ErrorToast } from "../../../CustomHooks/ErrorToast";
import { WarningToast } from "../../../CustomHooks/WarningToast";
import { SuccessToast } from "../../../CustomHooks/SuccessToast";
import {
  addEscalations, 
  removeEscalation,
  getEscalations,
  getMentionsList,
  getEscalationById,
  updateEscalations, 
} from "../../../services/escalationSevices"

import Swal from "sweetalert2";
import { getEmergencyContactList } from "../../../services/notifService";
import { ConfigurationContext } from "../../../Context/ConfigurationContext";

const Email = "Email";
const SMS = "SMS";
const Mobile = "Mobile";

const EscalationTemplateNew = ({
  addNewClicked,
  setAddNewClicked,
  isNotifFormEnabled,
  setIsNotifFormEnabled,
  escalationSaveBtnClicked,
  escalationDeleteBtnClicked,
  setEscalationSaveBtnClicked,
  setEscalationDeleteBtnClicked,
  setIsEmptyForm,
  isDarkTheme, 
  setButtonDisable,


  }) => {
    
    const { clients } = useContext(ConfigurationContext)
    const [selected, setSelected] = useState([]);
    const [activeTab, setActiveTab] = useState("Ack_Alert");
    const [escaltionList, setEscalationList] = useState([]);
    const [mainEscalationList, setMainEscalationList] = useState([]);
    const [escalationName, setEscalationName] = useState("");
    // const [emergencyContact, setEmergencyContact] = useState(false);
    const [selectedEscalationObj, setSelectedEscalationObj] = useState(null);
    const [escalationLevelName, setEscalationLevelName] = useState('');
    const [escalationLevels, setEscalationLevels] = useState([]);
    const [inputTypeListData, setInputTypeListData] = useState([]);
    const [inputTypeSelected, setInputTypeSelected] = useState(0);
    const [inputTypeNameSelected, setInputTypeNameSelected] = useState("");
    const [conditionTypeListData, setConditionTypeListData] = useState("");
    const [conditionNameSelected, setConditionNameSelected] = useState("");
    const [conditionIdSelected, setConditionIdSelected] = useState("");
    const [siteListData, setSiteListData] = useState([]);
    const [siteSelected, setSiteSelected] = useState([]);
    const [customerSelected, setCustomerSelected] = useState(0);
    const { alertTypeOptions } = useAlertType();
    const [countkey, setCountKey] = useState(0);
    const [parentCount, setParentCount] = useState(0);
    const [siteSelectedArr, setSiteSelectedArr] = useState([]);
    const [alertCodeSelected, setAlertCodeSelected] = useState([]);
    const [siteListString, setSiteListString] = useState("");

    // registered User
    const [userList, setUserList] = useState([]);

      // Error States
    const [escalationInputError, setEscalationInputError] = useState("");
    const [escalationCustomerError, setsEscalationCustomerError] = useState("")
    const [escalationNameError, setEscalationNameError] = useState("");
    const [escalationSiteError, setEscalationSiteError] = useState("");
    const [escalationEventcodeError, setEscalationEventCodeError] = useState("");
    const [escalationLevelNameError, setEscalationLevelNameError] = useState("");
    //email sms mobile  mention Input state
    const [mentionList, setMentionList] = useState([]);
    const [mentionSubjectEmailMessage, setMentionSubjectEmailMessage] = useState("");
    const [mentionEmailMessage , setMentionEmailMessage] = useState("");
    const [mentionSMSMessage, setMentionSMSMessage] = useState("");
    const [mentionMobileMessage, setMentionMobileMessage] = useState("")
    // //email sms mobile state
    const [subjectEmailMessage, setsubjectEmailMessage] = useState("");
    const [emailMessage , setemailMessage] = useState("");
    const [smsMessage, setSmsMessage] = useState("");
    const [mobileMessage, setmobileMessage] = useState("")
    // custom Contact
    const [selectedAllRegUsers, setSelectedAllRegUsers] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState({
      id: 0,
      name: "Customer(s)",
      selected: true,
      menuOpen: false,
      selectedCount: 0,
      totalCount: 0
    });

    const [isEditCustomer, setIsEditCustomer] = useState(false);
    const [parentCustomContact, setParentCustomContact] = useState([
      {
      Id: 0,
      Name: "",
      Designation: "",
      ContactNumber: "",
      ContactEmail: "",
    }])
    const [parentMainCustomerList, setParentMainCustomerList] = useState([
        {
          Id: 0,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        },
      ]);

    const [enableAdd, setEnableAdd] = useState("");
    // wait Time
    const [waitTime, setWaitTime] = useState("");
    // Search Filter
    const [escalationSearch, setEscalationSearch] = useState("");
    //
    
    // EditUSer
    const [checkOne, setCheckOne] = useState(false);
    const [checkTwo, setCheckTwo] = useState(false);
    const [topLeftCheck, setTopLeftCheck] = useState(false);
    const [topRightCheck, setTopRightCheck] = useState(false);
    const [midLeftCheck, setMidLeftCheck] = useState(false);
    const [midRightCheck, setMidRightCheck] = useState(false);
    
    // handler
    const [isLeftItemSelected, setIsLeftItemSelected] = useState(false);
    const [isRightItemSelected, setIsRightItemSelected] = useState(false);
    const [unselectedTemp, setUnSelectedTemp] = useState([]);
    const [unselectedTempFiltered, setUnSelectedTempFiltered] = useState([]);
    const [selectedTemp, setSelectedTemp] = useState([]);
    const [selectedTempFiltered, setSelectedTempFiltered] = useState([]);
    
    //
    const [searchTextOne, setSearchTextOne] = useState("");
    const [searchTextTwo, setSearchTextTwo] = useState("");
    const [searchTextThree, setSearchTextThree] = useState("");
    const [searchTextFour, setSearchTextFour] = useState("");
    const [isLeftSearch, setIsLeftSearch] = useState(false);
    const [isRightSearch, setIsRightSearch] = useState(false);
    
    //
    const [finalChildId, setFinalChildId] = useState(0);
    const [finalParentId, setFinalParentId] = useState(0);
    const [finalEntity, setFinalEntity] = useState("");

    // parent child state upadte 
    const [parentSelectedUsersList, setParentSelectedUsersList] = useState([]);
    const [parentEmergencyContact, setParentEmergencyContact] = useState([]);
    
    const siteListArray = siteListData.map((site) => ({
        value: site.SiteID,
        label: site.SiteName,
      }));

    const inputTypeListArray = inputTypeListData.map((inputType) =>({
      value : inputType.EscalationInputID,
      label : inputType.EscalationInputCondition
    }));

    // region useEffect start
    useEffect(() => {
      getSiteListFn(customerSelected);
    }, [customerSelected, countkey]);
    
    useEffect(() => {
      getEscalationList();
    }, []);
    
    useEffect(() => {
        getEscalationInputListfn(inputTypeSelected);
    }, [inputTypeSelected]);
      
    // useEffect(() => {
    //     let temp = siteSelected.map((item) => item.value).join(",");
    //     console.log ("temp21", temp)
    //     let oldString = siteListString;
    //     let oldArr = siteListString.split(",");
    //     let newArr = temp.split(",")
    //     if(oldArr.length > newArr.length){
    //       let diff = oldArr.filter((e) => !newArr.includes(e));
    //       let anotherTempArr = selectedUsersList;
    //       for (let i = 0; i < diff.length; i++) {
    //         anotherTempArr = anotherTempArr.filter((item) => item.Item2 != diff[i]);
    //         console.log ("anotherTempArr", anotherTempArr)
    //       }
    //       setSelectedUsersList(anotherTempArr);
    //     }
    //     console.log("setSiteListString", temp) 
    //     setSiteListString(temp);
    // }, [siteSelected]);
      
    // console.log("siteListString", siteListString)  
      
    // useEffect(() => {
    //     if (siteListString != "") {
    //       //if(true){
    //       let temp;
    //       let loggedInUser = JSON.parse(localStorage.getItem('user'))
    //       temp = loggedInUser?.Id
    
    //       // Comment the below or make it false if you want don't want to check via the dummy data.
    //       if (false) {
    
    //         let dummy = [{
    //           "Category": "1",
    //           "ContactLevel": [
    //             1,
    //             2,
    //             3
    //           ]
    //         },
    //         {
    //           "Category": "2",
    //           "ContactLevel": [
    //             1,
    //             2
    //           ]
    //         }, {
    //           "Category": "3",
    //           "ContactLevel": [
    //             1
    //           ]
    //         }]
    
    //         let arr = dummy.map((item) => {
    //           let obj = {
    //             "Category": item.Category,
    //             "CategorySelected": false,
    //             "ContactLevel": item.ContactLevel.map(contactId => ({
    //               "contactId": contactId,
    //               "contactSelected": false
    //             }))
    //           }
    //           return obj
    //         });
    
    //         let tempArr = arr.map((item) => {
    //           let obj
    //           let isPresent = false
    //           let str = []
    //           for (let i = 0; i < selectedEmergCont.length; i++) {
    //             if (item.Category == selectedEmergCont[i].categoryChecked) {
    //               isPresent = true
    //               str = selectedEmergCont[i].contactLevels
    //               break;
    //             }
    //           }
    //           if (isPresent) {
    //             obj = {
    //               ...item,
    //               "CategorySelected": true,
    //               "ContactLevel": item.ContactLevel.map(contactId => ({
    //                 "contactId": contactId.contactId,
    //                 "contactSelected": str.includes(contactId.contactId.toString())
    //               }))
    //             }
    //           } else {
    //             obj = {
    //               ...item
    //             }
    //           }
    //           return obj
    //         });
    
    //         setEmergencyContactList(tempArr)
    //         setCategoryMaster(tempArr)
    
    //       }
    
    //       // Comment the below if you want to check via the dummy data.
    
    //       getEmergencyContactList(temp, siteListString).then((res) => {
    //         if (res.Status == "success") {
    //           let arr = res.Data.map((item) => {
    //             let obj = {
    //               "Category": item.Category,
    //               "CategorySelected": false,
    //               "ContactLevel": item.ContactLevel.map(contactId => ({
    //                 "contactId": contactId,
    //                 "contactSelected": false
    //               }))
    //             }
    //             return obj
    //           });
    
    //           let tempArr = arr.map((item) => {
    //             let obj
    //             let isPresent = false
    //             let str = []
    //             for (let i = 0; i < selectedEmergCont.length; i++) {
    //               if (item.Category == selectedEmergCont[i].categoryChecked) {
    //                 isPresent = true
    //                 str = selectedEmergCont[i].contactLevels
    //                 break;
    //               }
    //             }
    //             if (isPresent) {
    //               obj = {
    //                 ...item,
    //                 "CategorySelected": true,
    //                 "ContactLevel": item.ContactLevel.map(contactId => ({
    //                   "contactId": contactId.contactId,
    //                   "contactSelected": str.includes(contactId.contactId.toString())
    //                 }))
    //               }
    //             } else {
    //               obj = {
    //                 ...item
    //               }
    //             }
    //             return obj
    //           });
    //           console.log("tempArr", tempArr)
    //           setEmergencyContactList(tempArr)
    //           setCategoryMaster(tempArr)
    
    //         } else {
    //           setCategoryMaster([])
    //           setEmergencyContactList([])
    //         }
    //       })
    //         .catch((err) => console.log(err));
    
    //     } else {
    //       setCategoryMaster([])
    //       setEmergencyContactList([])
    //     }
    //   }, [siteListString])

    useEffect(() => {
        if (escalationSaveBtnClicked) {
          setEscalationSaveBtnClicked(false);
          // Call Function For Adding
          addEscalation();
        }
    }, [escalationSaveBtnClicked]);

    useEffect(() => {
        if (!isNotifFormEnabled && selectedEscalationObj === null) {
            clearInputFields();
        }
        if (!isNotifFormEnabled && selectedEscalationObj !== null) {
          getEscalById(selectedEscalationObj);
          clearEscalationFields();
        }
    }, [isNotifFormEnabled]);

    useEffect(() => {
      if (escalationDeleteBtnClicked) {
        //Call Function to delete the Noti
          deleteEscalation();
        }
    }, [escalationDeleteBtnClicked]);
      
    useEffect(() => {
      getMentionsList()
        .then((res) => {
          if (res.Status == "success") {
          console.log("Response", res.Data)
          setMentionList(res.Data);
        }
      })
      .catch((err) => console.log(err));
    }, []);
    
    useEffect(() => {
      if (addNewClicked) {
        //Empty all the fields(
        clearInputFields();
      }
    }, [addNewClicked]);

    
    // region Function Start
    const updateParentSelectedUsersList = (newUsersList) => {
      console.log("newUsersList", newUsersList)
      setParentSelectedUsersList(newUsersList);
    };

    const updateParentCount = (count) => {
      console.log("count", count)
      setParentCount(count);
    };

    const updateParentMainCustomerList = (MainCustomerList) => {
      console.log("MainCustomerList", MainCustomerList)
      setParentMainCustomerList(MainCustomerList);
    };

    const updateParentCustomContact = (CContact) => {
      console.log("CContact", CContact)
      setParentCustomContact(CContact);
    };

    const updateParentEmergencyContact = (newContactList) => {
      console.log("selectedEmergCont", newContactList)
      setParentEmergencyContact(newContactList);
    };


    const handleTabChange = (tabkey) => {
      setActiveTab(tabkey);
    }

    const convertSecondsToHHMMSS = (seconds) => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
    
      // Format with zero padding for single-digit values
      const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
      console.log("formattedTime", formattedTime)
      
      return formattedTime;
    };

    const handleTimeChange = (date) => {
    if (date) {
      // Get the time part in HH:mm:ss format
      const formattedTime = date.toISOString().substr(11, 8); // Extract only HH:mm:ss
      setWaitTime(formattedTime); // Update waitTime state with formatted
    }
    };

    const getCurrentTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Adding 1 to month because months are 0-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
    
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const clearEscalationFields = () => {
          setEscalationInputError("");
          setsEscalationCustomerError("")
          setEscalationNameError("");
          setEscalationSiteError("");
          setEscalationEventCodeError("");
    };

    const deleteEscalation = () => {
      setButtonDisable(true);
      let user = JSON.parse(localStorage.getItem("user"));
        if (selectedEscalationObj == null) {
          WarningToast("Kindly select a Escalation to delete it.");
          return;
        }
        try {
          Swal.fire({
            title: "Are you sure?",
            //text: "Deleting this data access group will delete all the associations related to it!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!",
          }).then((result) => {
            if (result.isConfirmed) {
              console.log("selectedEscalationObj", selectedEscalationObj)
              let updateObj = {
                UserId : user?.Id,
                EscaltionConfigId : selectedEscalationObj.EscalationConfig[0]?.EscalationConfigID?.toString(),
                EscaltionConfigName : escalationName,
                EscalationInputID : (""),
                CustomerIds : (""),
                SiteIds : [""],
                AlertCodeIds : [""],
                EscalationMatrixInfo : [{
                 EscalationInputConditionID : "",
                 EscalationInputCondition : "",
                 Levels : [
                  {
                    EscalationDueTime : "", //Time in seconds
                    EscalationLevel : "", //autoIncrement 
                    EscalationLevelName : "", 
                    EscalationMessage : [
                     {
                       LstEscalationEmail: [
                        {
                          Subject: "",
                          
                          Body: ""
                          
                        }
                      ],
                      LstEscalationSMS: [
                       {
                         Body: ""
                         
                       }
                     ],
                     LstEscalationMobile: [
                      {
                        Body: ""
                        
                      }
                    ],

                }
              ], //email, mobile, sms json
               EmergencyContact : "",
               EscalationCustomContactDetails : [
                {
                  Id: "",
                  Name: "",
                  Designation: "",
                  ContactNumber: "",
                  ContactEmail: "",
                },
              ],
               EscalationUserDetails : [
                {
                  Item1: "",
                  Item2: "",
                },
              ]

              }
            ]
          }

          ]
        };
        // let userId = localStorage.getItem("UserID");
        let escalationid = selectedEscalationObj.EscalationConfig[0].EscalationConfigID;
        console.log("escalationid", escalationid)
        removeEscalation(escalationid)
                .then((res) => {
                  if (res.Status == "success") {
                    setButtonDisable(false);
                    SuccessToast(res.Message);
                    getEscalationList();
                    setEscalationDeleteBtnClicked(false);
                    clearInputFields();
                    setIsNotifFormEnabled(true);
                    setIsEmptyForm(true);
                  }
                })
                .catch((err) => console.log(err));
            } else {
              setButtonDisable(false);
              setEscalationDeleteBtnClicked(false);
            }
          });
        } catch (error) {
          console.log(error);
        }
    };

    const handleAddLevel = () => {
      console.log("Button clicked");
  
      // let lastForm = mainCustomerList[mainCustomerList.length - 1];
      // let contactNameEntered = lastForm?.Name;
      // let contactEmailEntered = lastForm?.ContactEmail;
      // let contactNumberEntered = lastForm?.ContactNumber;

      // const emailPattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;
      
      // if (contactNameEntered && contactEmailEntered && contactNumberEntered) {
      //  if (enableAdd) {
      //    WarningToast("Please complete the contact details to add another");
      //  } else {
      //    if (emailPattern.test(contactEmailEntered)) {
      //           // Valid email logic
      //    } else {
      //      ErrorToast("Please enter email id properly");
      //      setButtonDisable(false);
      //      return;
      //     }
      //     if (contactNumberEntered.length !== 10) {
      //           ErrorToast("Please enter contact number properly");
      //           setButtonDisable(false);
      //           return;
      //         }
      //       }
      //     }
      
      // let isEmptyFields = false;
      // if (mainCustomerList.length === 1) {
      //   for (let x = 0; x < mainCustomerList.length; x++) {
      //     if (
      //       (mainCustomerList[x].Name == "" ||
      //         mainCustomerList[x].ContactNumber == "" ||
      //         mainCustomerList[x].ContactEmail == "") &&
      //       !(
      //         mainCustomerList[x].Name == "" &&
      //         mainCustomerList[x].ContactNumber == "" &&
      //         mainCustomerList[x].ContactEmail == "" &&
      //         mainCustomerList[x].Designation == ""
      //       )
      //     ) {
      //       ErrorToast("Kindly complete the custom contact details.");
      //       setButtonDisable(false);
      //       return;
      //     }
      //   }
      // } else {
      //   for (let x = 0; x < mainCustomerList.length; x++) {
      //     if (
      //       mainCustomerList[x].Name == "" ||
      //       mainCustomerList[x].ContactNumber == "" ||
      //       mainCustomerList[x].ContactEmail == "" ||
      //       mainCustomerList[x].Designation == ""
      //     ) {
      //       ErrorToast("Kindly complete the custom contact details.");
      //       setButtonDisable(false);
      //       return;
      //     }
      //   }
      // }
    
      // console.log("mainCustomerList", mainCustomerList)
      // Prepare custom contact data
      // let tempCustomContact = mainCustomerList.map((item) => {
      // let obj = {
      //   ...item,
      //   Id: item.Id.toString(),
      //  };
      //  return obj;
      // });
      // console.log("tempCustomContact", tempCustomContact)
  
      console.log("NescalationLevels before", escalationLevels)

      const nextLevel = escalationLevels.length + 1; // Correct level number
      const newLevelName = `Level ${nextLevel}`;
      const newLevel = {
        // Spread the existing escalation levels if any, and then add the new one
        ...selectedEscalationObj?.EscalationMatrixInfo[0]?.MatrixInfo[0].EscalationLevel || [],
        EscalationTriggerTypeID: "2",  // Default Trigger Type
        EscalationCheckTypeID: "2",    // Default Check Type
        EscalationLevel: nextLevel,  // Automatically set the next level
        EscalationDueTime: waitTime ? waitTime.toString() : "",  // Default Wait Time
        EscalationLevelName: newLevelName,  // You might want to dynamically set this (e.g., based on the level)
        EscalationMessage: [
          {
            LstEscalationEmail: [
              {
                Subject: mentionSubjectEmailMessage
                  .replaceAll("\\", "\\\\")
                  .replaceAll("'", `''`)
                  .replaceAll('"', '\\"'),
                Body: mentionEmailMessage
                  .replaceAll("\\", "\\\\")
                  .replaceAll("'", `''`)
                  .replaceAll('"', '\\"'),
              }
            ],
            LstEscalationSMS: [
              {
                Body: mentionSMSMessage
                  .replaceAll("\\", "\\\\")
                  .replaceAll("'", `''`)
                  .replaceAll('"', '\\"'),
              }
            ],
            LstEscalationMobile: [
              {
                Body: mentionMobileMessage
                  .replaceAll("\\", "\\\\")
                  .replaceAll("'", `''`)
                  .replaceAll('"', '\\"'),
              }
            ]
          }
        ], 
        EscalationContactDetails: [],
        EscalationUserDetails: [], 
        EscalationCustomContactDetails: []
      };
  
      setEscalationLevels(prevLevels => {
        // Ensure you preserve previous levels, and add the new one
        return [...prevLevels, newLevel];
      });

      console.log("NescalationLevels After", newLevel);
      console.log("Updated Escalation Levels", escalationLevels);
      
    };


    const addEscalation = () => {
      console.log("escalationLevels from Add", escalationLevels)
      setButtonDisable(true);  // Initially disable the button while validation is happening
      let validationError = "";
      let isValid = true;  // Flag to track form validity
    
      // Validate required fields
      if (inputTypeSelected == 0) {
        validationError += "escalation input-Kindly select input!,";
        isValid = false;
      }
    
      if (escalationName == "") {
        validationError += "escalation name-Kindly enter a name for the template!,";
        isValid = false;
      }
    
      if (customerSelected == 0) {
        validationError += "escalation customer-Kindly select some customer!,";
        isValid = false;
      }
    
      if (siteSelected.length === 0) {
        validationError += "escalation site-Kindly select some sites!,";
        isValid = false;
      }
    
      let tempSites = siteSelected.map((item) => item.value);
    
      if (alertCodeSelected.length === 0) {
        validationError += "escalation event-Kindly select a type of event!,";
        isValid = false;
      }
    
      // Validation for escalation levels
      for (let i = 0; i < escalationLevels.length; i++) {
        const level = escalationLevels[i];

        if (!level.EscalationDueTime || level.EscalationDueTime.trim() === "") {
          ErrorToast(`Level ${i + 1}: Please provide the due time for escalation.`);
          isValid = false;
        }
    
        if (!level.emailSubject || level.emailSubject.trim() === "") {
          ErrorToast(`Level ${i + 1}: Please provide the subject for the email notification.`);
          isValid = false;
        }
    
        if (!level.emailBody || level.emailBody.trim() === "") {
          ErrorToast(`Level ${i + 1}: Please provide the body for the email notification.`);
          isValid = false;
        }
    
        if (!level.smsBody || level.smsBody.trim() === "") {
          ErrorToast(`Level ${i + 1}: Please provide the body for the SMS notification.`);
          isValid = false;
        }
    
        if (!level.mobileBody || level.mobileBody.trim() === "") {
          ErrorToast(`Level ${i + 1}: Please provide the body for the mobile notification.`);
          isValid = false;
        }

        
      }
    
      // Handle validation error messages
      let templst = validationError.split(",");
      for (let i = 0; i < templst.length; i++) {
        if (templst[i].includes("escalation input-")) {
          setEscalationInputError(templst[i].replace("escalation input-", ""));
          continue;
        }
    
        if (templst[i].includes("escalation name-")) {
          setEscalationNameError(templst[i].replace("escalation name-", ""));
          continue;
        }
        if (templst[i].includes("escalation customer-")) {
          setsEscalationCustomerError(templst[i].replace("escalation customer-", ""));
          continue;
        }
        if (templst[i].includes("escalation site-")) {
          setEscalationSiteError(templst[i].replace("escalation site-", ""));
          continue;
        }
        if (templst[i].includes("escalation event-")) {
          setEscalationEventCodeError(templst[i].replace("escalation event-", ""));
          continue;
        }
      }
    
      // If validation fails, return early
      if (!isValid) {
        setButtonDisable(false);
        return;
      }
    
      let tempAlertType = alertCodeSelected.map((item) => item.value.toString());
      let user = JSON.parse(localStorage.getItem("user"));
      let currentTime = getCurrentTime();
      const escalationInputConditionID = activeTab === "Ack_Alert" ? "2" : "3"; // 2 for Ack_Alert, 3 for Closed_Alert
      const escalationInputCondition = activeTab === "Ack_Alert" ? "Ack_Alert" : "Closed_Alert"; // "Ack_Alert" or "Closed_Alert"
    
      if (selectedEscalationObj === null) {
        // Create a new escalation object
        let escalationObj = {
          UserID: user?.Id,
          EscalationConfigID: "",
          EscalationConfigName: escalationName
            .replaceAll("\\", "\\\\")
            .replaceAll("'", `''`)
            .replaceAll('"', '\\"'),
          EscalationInputID: inputTypeSelected,
          CustomerID: customerSelected,
          SiteIds: tempSites.toString(),
          ModifiedBy: user?.Id,
          EscalationConfigDescription: "",
          EscalationConfigFilterParameterID: "2",
          IsEnable: "1",
          CreatedBy: user?.Id,
          CreatedOn: currentTime,
          ModifiedOn: currentTime,
          AlertCodeIds: tempAlertType.toString(),
          OrganizationMasterID: JSON.parse(localStorage.getItem("user")).OrganizationMasterID.toString(),
          ParameterValue: "",
          EscalationMatrixInfo: {
            EscalationInputConditionID: escalationInputConditionID,
            EscalationInputCondition: escalationInputCondition,
            Level: escalationLevels.map((level, index) => ({
              ...level,
              EscalationTriggerTypeID: "2",
              EscalationCheckTypeID: "2",
              EscalationLevel: level.EscalationLevel.toString(),
              EscalationDueTime: level.EscalationDueTime || "",
              EscalationLevelName: level.EscalationLevelName,
              EscalationMessage: [
                {
                  LstEscalationEmail: [
                    {
                      Subject: level.emailSubject || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                      Body: level.emailBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ],
                  LstEscalationSMS: [
                    {
                      Body: level.smsBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ],
                  LstEscalationMobile: [
                    {
                      Body: level.mobileBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ]
                }
              ],
              EscalationContactDetails: level.EscalationContactDetails || [],
              EscalationCustomContactDetails: level.EscalationCustomContactDetails || [],
              EscalationUserDetails: level.EscalationUserDetails || []
            }))
          },
        };
    
        // Call the API to add a new escalation
        console.log("escalationObj", escalationObj)
        addEscalations(escalationObj)
          .then((res) => {
            if (res.Status == "success") {
              setButtonDisable(false);
              SuccessToast(res.Message);
              getEscalationList();  // Refresh the escalation list
              clearInputFields();  // Clear form fields
              setEscalationSaveBtnClicked(false);  // Reset save button state
            } else {
              setButtonDisable(false);
              ErrorToast(res.Message);
            }
          })
          .catch((err) => {
            console.log(err);
            setButtonDisable(false);
            ErrorToast("An error occurred while adding the escalation.");
          });
      } else {
        // Update existing escalation logic
        let updateObj = {
          UserID: user?.Id,
          EscalationConfigID: selectedEscalationObj.EscalationConfig[0]?.EscalationConfigID?.toString(),
          EscalationConfigName: escalationName
            .replaceAll("\\", "\\\\")
            .replaceAll("'", `''`)
            .replaceAll('"', '\\"'),
          EscalationInputID: inputTypeSelected.toString(),
          CustomerID: customerSelected,
          SiteIds: tempSites.toString(),
          ModifiedBy: user?.Id,
          EscalationConfigDescription: "",
          EscalationConfigFilterParameterID: "2",
          IsEnable: "1",
          CreatedBy: user?.Id,
          CreatedOn: currentTime,
          ModifiedOn: currentTime,
          AlertCodeIds: tempAlertType.toString(),
          OrganizationMasterID: JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
          ParameterValue: "",
          EscalationMatrixInfo: {
            EscalationInputConditionID: "2",
            EscalationInputCondition: "Ack ",
            Level: escalationLevels.map((level, index) => ({
              ...level,
              EscalationTriggerTypeID: "2",
              EscalationCheckTypeID: "2",
              EscalationLevel: level.EscalationLevel.toString(),
              EscalationDueTime: level.EscalationDueTime || "",
              EscalationLevelName: level.EscalationLevelName,
              EscalationMessage: [
                {
                  LstEscalationEmail: [
                    {
                      Subject: level.emailSubject || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                      Body: level.emailBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ],
                  LstEscalationSMS: [
                    {
                      Body: level.smsBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ],
                  LstEscalationMobile: [
                    {
                      Body: level.mobileBody || ""
                        .replaceAll("\\", "\\\\")
                        .replaceAll("'", `''`)
                        .replaceAll('"', '\\"'),
                    }
                  ]
                }
              ],
              EscalationContactDetails: level.EscalationContactDetails || [],
              EscalationCustomContactDetails: level.EscalationCustomContactDetails || [],
              EscalationUserDetails: level.EscalationUserDetails || []
            }))
          },
        };
    
        // Call the API to update the escalation
        updateEscalations(updateObj)
          .then((res) => {
            if (res.Status === "success") {
              setButtonDisable(false);
              SuccessToast(res.Message);
              getEscalationList();
              setIsNotifFormEnabled(false);
              setEscalationSaveBtnClicked(false);
            } else {
              setButtonDisable(false);
              ErrorToast(res.Message);
            }
          })
          .catch((err) => {
            console.log(err);
            setButtonDisable(false);
            ErrorToast("An error occurred while updating the escalation.");
          });
      }
    };
    

    console.log("escalationLevelsObj", escalationLevels)
    
    const handleRemoveLevel = (levelToRemove) => {
      console.log("Removing level", levelToRemove);
    
      setEscalationLevels(prevLevels => {
        const updatedLevels = prevLevels.filter(level => level.EscalationLevel !== levelToRemove);
        return updatedLevels.map((level, index) => {
          return {
            ...level,
            EscalationLevel: (index + 1).toString(),  // Re-assign the level number based on the new index
            EscalationLevelName: `Level ${(index + 1)}`, // Update the level name to match the new index
          };
        });
      });
    
      console.log("Escalation Levels after removal", escalationLevels);
    };
    

    const handleLevelChange = (level, field, value) => {
      setEscalationLevels(prevLevels =>
        prevLevels.map(prevLevel => 
          prevLevel.EscalationLevel === level.EscalationLevel
            ? { ...prevLevel, [field]: value } // Dynamically update the field
            : prevLevel
        )
      );
    };
    

    const parseXMLForCustomContact = (xmlString, tagName) => {
      // Create a new DOMParser to parse the XML
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "text/xml");
  
      console.log('Parsed XML Document:', xmlDoc);
  
      const nodes = xmlDoc.getElementsByTagName(tagName);
  
      console.log('CustomContact Nodes:', nodes);
  
      // Convert the NodeList to an array and map each node
      const parsedArray = Array.from(nodes).map(node => ({
          Id: node.getElementsByTagName("Id")[0]?.textContent,
          Name: node.getElementsByTagName("Name")[0]?.textContent,
          Designation: node.getElementsByTagName("Designation")[0]?.textContent,
          ContactNumber: node.getElementsByTagName("ContactNumber")[0]?.textContent,
          ContactEmail: node.getElementsByTagName("ContactEmail")[0]?.textContent
      }));
      
      console.log('Parsed Array:', parsedArray);
  
      return parsedArray;
  };
  
 
  
    const handleEscalationLevel = (item) => {
    console.log("itemsFromEscalationLevel", item);
  
    if (item?.EscalationMatrixInfo?.length > 0) {
      const matrixInfo = item.EscalationMatrixInfo[0]?.MatrixInfo;
      console.log("matrixInfo", matrixInfo);
  
      if (matrixInfo && matrixInfo.length > 0) {
        const updatedEscalationLevels = matrixInfo.map((matrix, index) => {
          const escalationMessage = matrix.EscalationMessage;
          console.log("EscalationMessage:", escalationMessage);
  
          const extractedValuesMessage = extractXmlValues(escalationMessage);
          console.log("Extracted Message Values:", extractedValuesMessage);
  
          const EscalationDueTime = convertSecondsToHHMMSS(matrix.EscalationDueTime);
          console.log("Extracted DueTime Values:", EscalationDueTime);
          setWaitTime(EscalationDueTime);

         // Custom Contact Field
         let parsedContacts = [];
         if (matrix.EscalationCustomContactDetails?.length > 0) {
           const customContactXML = matrix.EscalationCustomContactDetails;
           console.log("customContactXML", customContactXML);
                   // Parse the contacts for each escalation level
           parsedContacts = parseXMLForCustomContact(customContactXML, "CustomContact");
           console.log("customContactXMLparsedContacts", parsedContacts);

           let initCount = 
             matrix.EscalationCustomContactDetails[matrix.EscalationCustomContactDetails.length - 1].Id;
           updateParentCount(initCount);
           updateParentMainCustomerList(parsedContacts);
           updateParentCustomContact(parsedContacts);
         } else {
           const defaultContact = [
             {
               Id: 0,
               Name: "",
               Designation: "",
               ContactNumber: "",
               ContactEmail: "",
             }
           ];
           updateParentCount(0);
           updateParentMainCustomerList(defaultContact);
           updateParentCustomContact(defaultContact);
         }


          // Selected Register user
          let parsedEscalationUsers = [];
          const escalationUserXML = matrix.EscalationUserDetails;
          console.log("parsedEscalationUsersXML", escalationUserXML)
          if (escalationUserXML?.length > 0) {
            parsedEscalationUsers = parseXML(escalationUserXML, "User");
            console.log("parsedEscalationUsers", parsedEscalationUsers)
            updateParentSelectedUsersList(parsedEscalationUsers);
          }else{
            updateParentSelectedUsersList([]);
          }

          // Selected Emergency Contact 
          let parsedEscalationContacts = [];
          const escalationContactXML = matrix.EscalationContactDetails;
          console.log("parsedEscalationContactXML", escalationContactXML)
          if (escalationContactXML?.length > 0) {
            parsedEscalationContacts = parseXML(escalationContactXML, "Contact");
            console.log("parsedEscalationContacts", parsedEscalationContacts)
            updateParentEmergencyContact(parsedEscalationContacts)
            // if (parsedEscalationContacts.length > 0) {
            //     // setEmergencyContact(true);
            //   // setSelectedEmergCont(parsedEscalationContacts);
            // } else {
            //     //  setEmergencyContact(false);
            //   setSelectedEmergCont([]);
            // }
         }
  
          return {
            EscalationLevel: matrix.EscalationLevel,
            EscalationLevelName: matrix.EscalationLevelName,
            EscalationDueTime: EscalationDueTime || '',
            emailSubject: extractedValuesMessage.emailSubject || '',
            emailBody: extractedValuesMessage.emailBody || '',
            smsBody: extractedValuesMessage.smsBody || '',
            mobileBody: extractedValuesMessage.mobileBody || '',
            EscalationContactDetails: parsedEscalationContacts || [],
            EscalationCustomContactDetails: parsedContacts || [],
            EscalationUserDetails: parsedEscalationUsers || []
            
          };
        });
  
        console.log("updatedEscalationLevelsCalled", updatedEscalationLevels);
        console.log("I am called")
        setEscalationLevels(updatedEscalationLevels);
      } else {
        console.error("No escalation matrix information found.");
      }
    } else {
      console.error("EscalationMatrixInfo is not available or empty.");
    }
    };
  
      
    const getEscalationList = () => {
        getEscalations()
        .then((res) => {
            if (res.Status == "success") {
              console.log("resultSet", res.Data.EscalationConfig)
              setEscalationList(res.Data.EscalationConfig);
              setMainEscalationList(res.Data.EscalationConfig);
            } else {
            }
          })
          .catch((err) => console.log(err));
    };
        
    console.log("EscaltionList", escaltionList)
    console.log("EscaltionListMain", mainEscalationList)
    console.log("selectedEscalationObj",selectedEscalationObj)
    console.log("EscaltionName", escalationName)
    console.log("DataEsclationLevels", escalationLevels)
    console.log("SelectedArr", siteSelectedArr)
    console.log("userList", userList)
    
        
    const getSiteListFn = (clientIds) => {
      try {
        getSiteList(clientIds).then((resp) => {
          if (resp !== undefined) {
            console.log("resppp", resp.Data)
            if (resp.Status === "success") {
              if (resp.Data === null) {
                setSiteListData([]);
              } else {
                setSiteListData(resp.Data);
                if (selectedEscalationObj != null) {
                  
                  // Ensure the ParameterValue is being accessed properly
                  const parameterValue = selectedEscalationObj.EscalationMatrixInfo[0].filter_result[0].ParameterValue;
                  
                  // Extract values from XML
                  const extractedValues = extractXmlValues(parameterValue);
    
                  console.log("Extracted Values", extractedValues);
                  
                  // Make sure SiteIds from XML are an array and filter based on that
                  let siteIds = extractedValues.siteIds; // The extracted SiteIds
                  
                  console.log("Extracted SiteIds", siteIds);
                  
                  let temp = resp.Data.map((site) => ({
                    value: site.SiteID.toString(),  // Ensure SiteID is a string
                    label: site.SiteName,
                  }));
                  console.log("Temp (mapped data):", temp);
                  let siteIdsAsNumbers = siteIds.map((id) => Number(id));
                  console.log("Temp12 (mapped data) :", siteIdsAsNumbers)
                  
                  // Ensure siteIds is an array
                  let siteTempArr = temp.filter((site) =>{
                    const siteValueAsNumber = Number(site.value);
                    const match = siteIdsAsNumbers.includes(siteValueAsNumber) 
                    return match // Ensure comparison is between numbers
                  });
                  //   {
                  //     selectedEscalationObj.Es
                  //     // siteIds.includes(site.value)  // Ensure both are strings for comparison
                  //     return siteIds.includes(site.value); 
                  //   }
                  // );
                  console.log("Temp1 (mapped data):", siteTempArr);
                  setSiteSelected(siteTempArr);
                }
              }
            } else {
              setSiteListData([]);
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    };
    
    const getEscalationConditionListfn = (EscalationInputConditionID) => {
        try {
          getEscalationConditionList(EscalationInputConditionID).then((resp) => {
            if (resp != undefined) {
              if (resp.Status == "success") {
                if (resp.Data == null) {
                  setConditionNameSelected("");
                  setConditionIdSelected("")
                  
                } else {
                  setConditionTypeListData(resp.Data);
                  
                  let temp = resp.Data.map((inputcondition) => ({
                    value: inputcondition.EscalationInputConditionID,
                    label: inputcondition.EscalationInputCondition,
                  }));
                    let ConditionNameArr = temp.filter((inputcondition) =>
                      selectedEscalationObj.EscalationMatrixInfo.EscalationInputCondition.includes(inputcondition.label)
                    );
                    let ConditionIdArr = temp.filter((inputcondition) =>
                      selectedEscalationObj.EscalationMatrixInfo.EscalationInputConditionID.includes(inputcondition.value)
                    );

                    setConditionNameSelected(ConditionNameArr);
                    setConditionIdSelected(ConditionIdArr);
                    
                  }
                }
    
              } else {
                setConditionTypeListData("")
              }
            }
          );
        } catch (error) {
          console.error(error);
        }
    };

    const getEscalationInputListfn = () => {
      try {
        getEscalationInputList().then((resp) => {
          if (resp != undefined) {
            if (resp.Status == "success") {
              console.log("ttt", resp.Data)
              setInputTypeListData(resp.Data)
            }
            
          } else {
            setInputTypeListData([])
          }
        }
      );
    } catch (error) {
      console.error(error);
    }
    };

    const clearInputFields = () => {
      setEscalationName("");
      setInputTypeSelected("");
      setCustomerSelected(0)
      setSiteSelected([]);
      setSiteListString("");
      setAlertCodeSelected([]);
      setEscalationLevels([]);
      setsubjectEmailMessage("");
      setMentionSubjectEmailMessage("");
      setemailMessage("");
      setMentionEmailMessage("");
      setSmsMessage("");
      setmobileMessage("");
      setWaitTime("");
      setParentEmergencyContact([]);
      // setEmergencyContact(false);
      setParentSelectedUsersList([])
      setUserList([]);
      setParentCustomContact([
        {
          Id: 1,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        },
      ]);
      setParentMainCustomerList([
        {
          Id: 1,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        },
      ]);
      setAddNewClicked(false);
      setSelectedEscalationObj(null);
    };
   
    const escalationSelected = (item) => {
          if (
            item.EscalationConfigID ==
            selectedEscalationObj?.EscalationConfigID
          ) {
            console.log("item", item)
            console.log("selectedEscalationObj",selectedEscalationObj)
            return;
          }
          if (selectedEscalationObj != null && isNotifFormEnabled) {
            Swal.fire({
              title: "Operation in Progress.",
              text: "You have started the operation for a Escalation, do you want to discard any changes and continue to the other Escalation.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#027aaa",
              cancelButtonColor: "#d33",
              confirmButtonText: "Ok!",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                getEscalById(item);
              }
            });
          } else {
            getEscalById(item);
            setIsNotifFormEnabled(false)
            setIsEmptyForm(false);
          
          }
    };

    const extractXmlValues = (xmlString) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "application/xml");
    
      // Extract CustomerID, SiteIds, and AlertCodeIds
      const customerID = xmlDoc.getElementsByTagName("CustomerID")[0]?.textContent;
      console.log("customerID", customerID)
      const siteIds = Array.from(xmlDoc.getElementsByTagName("SiteId")).map(site => site.textContent);
      console.log("siteIds", siteIds);
      const alertCodeIds = Array.from(xmlDoc.getElementsByTagName("AlertCodeId")).map(code => code.textContent);
      console.log("customerID",customerID,"siteIds", siteIds, "alertCodeIds",alertCodeIds )

      const emailSubject = xmlDoc.getElementsByTagName("Email")[0]?.getElementsByTagName("Subject")[0]?.textContent || '';
      console.log("emailSubject", emailSubject);

      const emailBody = xmlDoc.getElementsByTagName("Email")[0]?.getElementsByTagName("Body")[0]?.textContent || '';
      console.log("emailBody", emailBody);
      // Extract SMS Body
      const smsBody = xmlDoc.getElementsByTagName("SMS")[0]?.getElementsByTagName("Body")[0]?.textContent || '';
      console.log("smsBody", smsBody);
      // Extract Mobile Body
      const mobileBody = xmlDoc.getElementsByTagName("Mobile")[0]?.getElementsByTagName("Body")[0]?.textContent || '';
      console.log("mobileBody", mobileBody);
      return {
        emailSubject,
        emailBody,
        smsBody,
        mobileBody,
        customerID,
        siteIds,
        alertCodeIds,
      };
    };
    
    const handleDataSetting = (item) => {
      console.log("Hiii From handleDataSetting ")
      console.log("items", item)
      // Assuming item.EscalationMatrixInfo.filter_result.ParameterValue is the XML string
      const parameterValue = item.EscalationMatrixInfo[0].filter_result[0].ParameterValue;
      console.log("extractedValues", parameterValue)
      // Extract values from XML
      const extractedValues = extractXmlValues(parameterValue);
      console.log("extractedValues", extractedValues)
    
      // Set extracted customerID, siteIds, and alertCodeIds to state
      setCustomerSelected(extractedValues.customerID);
      // Set countKey (incrementing it)
      let count = countkey + 1;
      setCountKey(count);
      
      setSiteSelectedArr(extractedValues.siteIds);
    
      // Filtering alert codes based on extracted alertCodeIds
      let alertCodeArr = alertTypeOptions.filter((event) =>
        extractedValues.alertCodeIds.includes(event.value.toString())
      );
      setAlertCodeSelected(alertCodeArr);

     
    };

    const isEmpty = (obj) => {
      return Object.keys(obj).length === 0;
    }    
    
    const parseXML = (xmlString, tagName) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "application/xml");
      const parsedData = [];
    
      const elements = xmlDoc.getElementsByTagName(tagName);
    
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const data = {};
    
        // For each child of the element, we'll gather the data
        for (let j = 0; j < element.children.length; j++) {
          const child = element.children[j];
          const tagName = child.tagName;
          const tagValue = child.textContent;
    
          // If the tag already exists in data, convert it into an array
          if (data[tagName]) {
            if (Array.isArray(data[tagName])) {
              data[tagName].push(tagValue);  // Add to the existing array
            } else {
              data[tagName] = [data[tagName], tagValue];  // Convert the existing value into an array and add the new value
            }
          } else {
            data[tagName] = tagValue;
          }
        }
    
        // Ensure that ContactLevels is always an array
        if (data.ContactLevels && !Array.isArray(data.ContactLevels)) {
          data.ContactLevels = [data.ContactLevels];
        }
    
        // Only add the data if it's not empty
        if (!isEmpty(data)) {
          parsedData.push(data);
        }
      }
      console.log("parsedData", parsedData)
      return parsedData;
    };
    
    const getEscalById = (item) => {
      getEscalationById(item.EscalationConfigID)
        .then((res) => {
          if (res.Status === "success") {
            let item = res.Data;
            console.log("Fetched item:", item);
            setSelectedEscalationObj(item);
            setEscalationName(item.EscalationConfig[0].EscalationConfigName);
            setInputTypeSelected(item.EscalationConfig[0].EscalationInputID);
            let count = countkey + 1;
            setCountKey(count);
            handleDataSetting(item);
            handleEscalationLevel(item);
          }
          setIsNotifFormEnabled(false);
        })
        .catch((err) => {
          console.log(err);
        });
    };
     
    
    const searchEsacaltionList = (e) => {
      setEscalationSearch(e.target.value);
      let tempArr = mainEscalationList.filter((x) =>
        x.EscalationConfigName.toLowerCase().includes(
          e.target.value.toLowerCase()
        )
      );
      setEscalationList(tempArr);
    };

    const selectAllHandler = (e, type) => {
      if (type === "ONE") {
        let temp = checkOne;
        setCheckOne(!checkOne);
        const tempArr = unselectedTempFiltered.map((item, index) => {
          let obj = {
            ...item,
            isItSelected: !checkOne
          }
          return obj;
        })
        if (temp) {
          setIsLeftItemSelected(false);
        } else {
          setIsLeftItemSelected(true);
        }
        setUnSelectedTemp(tempArr);
        setUnSelectedTempFiltered(tempArr);
      } else {
        let temp = checkTwo;
        setCheckTwo(!checkTwo);
        const tempArr = selectedTempFiltered.map((item, index) => {
          let obj = {
            ...item,
            isItSelected: !checkTwo
          }
          return obj
        })
        if (temp) {
          setIsRightItemSelected(false);
        } else {
          setIsRightItemSelected(true);
        }
        setSelectedTemp(tempArr);
        setSelectedTempFiltered(tempArr);
      }
    };

    const searchHandlerOne = (e) => {
      setSearchTextOne(e.target.value);
      if (e.target.value == "") {
        let obj = {
          entity: finalEntity,
          // fileName: groupName + "_" + localStorage.getItem('authCode'),
          // parentId: finalParentId,
          // childId: finalChildId,
          pageNumber: "1",
          pageType: "available",
          searchText: e.target.value
        }
        //getMasterFunc(obj, AVAILABLE);
        setIsLeftSearch(false);
      }
    };

    const subjectHandler = (e, newValue, newPlainTextValue) => {
      let tempString = newPlainTextValue;
      setsubjectEmailMessage(e.target.value);
      setMentionSubjectEmailMessage(tempString);    
    };

    const messageHandler = (e,type, newValue, newPlainTextValue) => {
     let tempString = newPlainTextValue;
     switch (type){
      case Email:
        setemailMessage(e.target.value);
        setMentionEmailMessage(tempString);
        break;
      case SMS :
        setSmsMessage(e.target.value);
        setMentionSMSMessage(tempString);
        break;
      case Mobile :  
        setmobileMessage(e.target.value);
        setMentionMobileMessage(tempString);
        break;
     }     
    };


  return (
    <div className="col-lg-12 mt-2">
        <div className="SiteMainContainer">
          <div className="SiteLeftContainer">
            <div className="m-2 HeaderSiteList">
               <input
                  id="Search_txt"
                  className="SearchViewInput1"
                  type="text"
                  placeholder="Search"
                  value={escalationSearch}
                  onChange={(e) => searchEsacaltionList(e)}
                />
                <div className="SearchTextDivConfigTool">
                  {isDarkTheme ? (
                    <img className="EyeIcon" src={SearchIcon} alt="search icon" />
                  ) : (
                    <img
                      className="EyeIcon"
                      src={SearchIconWhite}
                      height="15"
                      alt="search icon"
                    />
                  )}
                </div>
            </div>
            <div className="NotificationList">
              {escaltionList &&
                (escaltionList?.length > 0 ? (
                  
                  escaltionList.map((item) => {
                  
                    return (
                      <div
                        className={
                          selectedEscalationObj?.EscaltionConfigId ===
                            item.EscalationConfigID
                            ? "OneList SelectedList"
                            : "OneList"
                        }
                        key={item.EscalationConfigID}
                        onClick={(e) => {
                          e.stopPropagation();
                          escalationSelected(item);
                          clearEscalationFields();
                        }}
                      >
                        <p className="ListofText">
                          {item.EscalationConfigName}
                        </p>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-data-found">
                    <p>No Escalation Found</p>
                  </div>
                ))}
              {!escaltionList && (
                <div className="no-data-found">
                  No Escalation List Available
                </div>
              )}
            </div>           
          </div>
          <div className="SiteRightContainer">
            <div className="Notification-form escForm">
                <div className="inputMainContainer w40dot75rem mt30">
                  <div className="inputTypeLabelContainer">
                    <label className="formFieldLabels">Name</label>
                    <input className="inputType" 
                    placeholder="Enter escalation name here"
                    value={escalationName}
                    onChange={(e) => {
                      setEscalationName(e.target.value);
                      setEscalationNameError("");
                    }}
                    disabled={!isNotifFormEnabled}
                    />
                    <p className="Error_P" style={{ float: "left" }}>
                      <span> {escalationNameError} </span>
                    </p>
                  </div>
                </div>

                <div className="grid-container Notificationgrid-container grid-container--fit mt20">
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Input Type</label>
                      <select
                         name="CountryName"
                         class="inputType ArrowSelectClass"
                        //  options={inputTypeListArray}
                         value={inputTypeSelected}
                         onChange={(e) => {
                           setInputTypeSelected(e.target.value)
                           setEscalationInputError("")
                          }}
                          disabled={!isNotifFormEnabled}
                      >
                        <option key="0" disabled={false} value="0" id="0">
                          Select Input Type
                        </option>
                        {inputTypeListData?.map((item) => (
                          <option
                            value={item.EscalationInputID}
                            key={item.EscalationInputID}
                            id={item.EscalationInputType}
                          >
                            {item.EscalationInputType}
                          </option>
                        ))}
                      </select>
                      <p className="Error_P" style={{ float: "left" }}>
                        <span>{escalationInputError}</span>
                      </p>
                    </div>
                  </div>
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Customer</label>
                      <select
                         name="CountryName"
                         class="inputType ArrowSelectClass"
                         disabled={!isNotifFormEnabled}
                         value={customerSelected}
                         onChange={(e) => {
                            getSiteListFn(e.target.value)
                            setCustomerSelected(e.target.value)
                            setsEscalationCustomerError("")
                         }}   
                      >
                        <option key="0" disabled={false} value="0" id="0">
                          Select Customer
                        </option>
                        {clients?.map((item) => (
                          <option
                            value={item.ClientId}
                            key={item.ClientId}
                            id={item.ClientName}
                          >
                            {item.ClientName}
                          </option>
                        ))}
                      </select>
                      <p className="Error_P" style={{ float: "left" }}>
                        <span>{escalationCustomerError}</span>
                      </p>
                    </div>
                  </div>

                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Site</label>
                      <MultiSelect
                         disabled={!isNotifFormEnabled}
                         options={siteListArray}
                         value={siteSelected}  
                         onChange={(e) => {
                           setSiteSelected(e); 
                           setEscalationSiteError("");
                          }}
                         labelledBy={"Select"}
                         overrideStrings={{
                           selectSomeItems: "Select site",
                           allItemsAreSelected: "All sites are selected",
                          }}
                         ArrowRenderer={() => <DropArrow />}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {escalationSiteError} </span>
                      </p>
                    </div>
                  </div>
                  
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Alert Code</label>
                      <MultiSelect
                        disabled={!isNotifFormEnabled}
                        options={alertTypeOptions}
                        value={alertCodeSelected}
                        onChange={(e) => {
                          setAlertCodeSelected(e);
                          setEscalationEventCodeError("");
                        }}
                        labelledBy={"Select"}
                        overrideStrings={{
                          selectSomeItems: "Select Alert code type",
                          allItemsAreSelected: "All Alertt codes are selected",
                        }}
                        ArrowRenderer={() => <DropArrow />}
                        // options={options}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {escalationEventcodeError} </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{float:"left",width:"100%"}}>
                    <Tabs defaultActiveKey="Ack_Alert" activeKey={activeTab} onSelect={handleTabChange} id="uncontrolled-tab-example" className="AlertTemplateTab">
                        <Tab eventKey="Ack_Alert" title="Acknowledge Alert">
                            <div style={{display:"flex", width:"100%", justifyContent:"space-between", alignItems:"center"}}>
                              <EcsAccordion
                              setIsNotifFormEnabled = {setIsNotifFormEnabled}
                              handleTimeChange = {handleTimeChange}
                              siteSelected={siteSelected}
                              setSiteSelected={setSiteSelected}
                              isDarkTheme={isDarkTheme}
                              setsubjectEmailMessage= {setsubjectEmailMessage}
                              parentSelectedUsersList = {parentSelectedUsersList}
                              updateParentSelectedUsersList={updateParentSelectedUsersList} 
                              parentEmergencyContact = {parentEmergencyContact}
                              updateParentEmergencyContact = {updateParentEmergencyContact}
                              mentionList = {mentionList}
                              setMentionList = {setMentionList}
                              setMentionSubjectEmailMessage = {setMentionSubjectEmailMessage}
                              mentionSubjectEmailMessage = {mentionSubjectEmailMessage}
                              setemailMessage = {setemailMessage}
                              setMentionEmailMessage = {setMentionEmailMessage}
                              setSmsMessage = {setSmsMessage}
                              setMentionSMSMessage = {setMentionSMSMessage}
                              setmobileMessage = {setmobileMessage}
                              setMentionMobileMessage = {setMentionMobileMessage}
                              subjectEmailMessage = {subjectEmailMessage}
                              emailMessage = {emailMessage}
                              smsMessage = {smsMessage}
                              mobileMessage = {mobileMessage}
                              parentCustomContact ={parentCustomContact}
                              updateParentCustomContact = {updateParentCustomContact}
                              waitTime = {waitTime}
                              setWaitTime = {setWaitTime}
                              userList={userList}
                              setUserList={setUserList}
                              addNewClicked={addNewClicked}
                              parentCount= {parentCount}
                              updateParentCount = {updateParentCount}
                              setEscalationLevelName= {setEscalationLevelName}
                              escalationLevelName = {escalationLevelName}
                              setEscalationLevels= {setEscalationLevels}
                              escalationLevels = {escalationLevels}
                              setEscalationLevelNameError = {setEscalationLevelNameError}
                              escalationLevelNameError = {escalationLevelNameError}
                              isNotifFormEnabled = {isNotifFormEnabled}
                              selectedEntity={selectedEntity}
                              isEditCustomer={isEditCustomer}
                              setTopLeftCheck={setTopLeftCheck}
                              topLeftCheck={topLeftCheck}
                              selectAllHandler={selectAllHandler}
                              searchHandlerOne={searchHandlerOne}
                              midLeftCheck={midLeftCheck}
                              setMidLeftCheck={setMidLeftCheck}
                              parentMainCustomerList = {parentMainCustomerList}
                              updateParentMainCustomerList = {updateParentMainCustomerList}
                              setEnableAdd={setEnableAdd}
                              subjectHandler = {subjectHandler}
                              messageHandler = {messageHandler}
                              Email = {Email}
                              SMS = {SMS}
                              Mobile = {Mobile}
                              handleAddLevel = {handleAddLevel}
                              handleRemoveLevel = {handleRemoveLevel}
                              handleLevelChange = {handleLevelChange}
                              /> 
                            </div>
                            <div className="mt-2" style={{ width: "100%", float: "left", display: "flex", justifyContent: "end", alignItems: "center" }}>
                              <button
                                type="button"
                                className="addCustomer"
                                style={{ marginBottom: "10px", display: "flex", alignItems: "center" }} // Ensure flex for horizontal alignment
                                onClick={handleAddLevel}
                                disabled={!isNotifFormEnabled}
                              >
                               <img src={AddNode} alt="plus icon add node" style={{ marginRight: "8px" }} /> {/* Spacing between icon and text */}
                                 <span style={{ fontSize: "14px", fontWeight: "bold"  }}>Add Level</span> {/* Text next to the icon */}
                              </button>
                            </div>
                           
                        </Tab>
                        {/* <Tab eventKey="Closed_Alert" title="Closed Alert">
                            <div style={{display:"flex", width:"100%", justifyContent:"space-between", alignItems:"center"}}>
                              <EcsAccordion
                              setIsNotifFormEnabled = {setIsNotifFormEnabled}
                              handleTimeChange = {handleTimeChange}
                              siteSelected={siteSelected}
                              setSiteSelected={setSiteSelected}
                              isDarkTheme={isDarkTheme}
                              setsubjectEmailMessage= {setsubjectEmailMessage}
                              parentSelectedUsersList = {parentSelectedUsersList}
                              updateParentSelectedUsersList={updateParentSelectedUsersList} 
                              parentEmergencyContact = {parentEmergencyContact}
                              updateParentEmergencyContact = {updateParentEmergencyContact}
                              mentionList = {mentionList}
                              setMentionList = {setMentionList}
                              setMentionSubjectEmailMessage = {setMentionSubjectEmailMessage}
                              mentionSubjectEmailMessage = {mentionSubjectEmailMessage}
                              setemailMessage = {setemailMessage}
                              setMentionEmailMessage = {setMentionEmailMessage}
                              setSmsMessage = {setSmsMessage}
                              setMentionSMSMessage = {setMentionSMSMessage}
                              setmobileMessage = {setmobileMessage}
                              setMentionMobileMessage = {setMentionMobileMessage}
                              subjectEmailMessage = {subjectEmailMessage}
                              emailMessage = {emailMessage}
                              smsMessage = {smsMessage}
                              mobileMessage = {mobileMessage}
                              parentCustomContact ={parentCustomContact}
                              updateParentCustomContact = {updateParentCustomContact}
                              waitTime = {waitTime}
                              setWaitTime = {setWaitTime}
                              userList={userList}
                              setUserList={setUserList}
                              addNewClicked={addNewClicked}
                              parentCount= {parentCount}
                              updateParentCount = {updateParentCount}
                              setEscalationLevelName= {setEscalationLevelName}
                              escalationLevelName = {escalationLevelName}
                              setEscalationLevels= {setEscalationLevels}
                              escalationLevels = {escalationLevels}
                              setEscalationLevelNameError = {setEscalationLevelNameError}
                              escalationLevelNameError = {escalationLevelNameError}
                              isNotifFormEnabled = {isNotifFormEnabled}
                              selectedEntity={selectedEntity}
                              isEditCustomer={isEditCustomer}
                              setTopLeftCheck={setTopLeftCheck}
                              topLeftCheck={topLeftCheck}
                              selectAllHandler={selectAllHandler}
                              searchHandlerOne={searchHandlerOne}
                              midLeftCheck={midLeftCheck}
                              setMidLeftCheck={setMidLeftCheck}
                              parentMainCustomerList = {parentMainCustomerList}
                              updateParentMainCustomerList = {updateParentMainCustomerList}
                              setEnableAdd={setEnableAdd}
                              subjectHandler = {subjectHandler}
                              messageHandler = {messageHandler}
                              Email = {Email}
                              SMS = {SMS}
                              Mobile = {Mobile}
                              handleAddLevel = {handleAddLevel}
                              handleRemoveLevel = {handleRemoveLevel}
                              handleLevelChange = {handleLevelChange}
                              /> 
                            </div>
                            <div className="mt-2" style={{ width: "100%", float: "left", display: "flex", justifyContent: "end", alignItems: "center" }}>
                              <button
                                type="button"
                                className="addCustomer"
                                style={{ marginBottom: "10px", display: "flex", alignItems: "center" }} // Ensure flex for horizontal alignment
                                onClick={handleAddLevel}
                                disabled={!isNotifFormEnabled}
                              >
                               <img src={AddNode} alt="plus icon add node" style={{ marginRight: "8px" }} /> 
                                 <span style={{ fontSize: "14px", fontWeight: "bold" }}>Add Level</span> 
                              </button>
                            </div>
                        </Tab> */}
                    </Tabs>
                </div>
            </div>
          </div>
        </div>
    </div>
  )
 
};

export default EscalationTemplateNew;
